<!-- Zweck: Stellt die HTML-Struktur für dashboard widgets merklisten component im Frontend bereit. -->
<dashboard-widget>
  <div icon>
    <svg-icon>merkliste</svg-icon>
  </div>
  <div header1 matTooltip="Merklisten ({{(svc.merklisten$|async)?.length}})">
    <a routerLink="/shop/merklisten">Merklisten ({{(svc.merklisten$|async)?.length}})</a>
  </div>
  <div content>
    @for (ml of svc.merklisten$|async; track ml) {
      <div>
        <button mat-button routerLink="/shop/merkliste/{{ml.id}}" style="text-align: left">
          {{ml.label}} ({{ml.artikel_count}} Artikel)
        </button>
      </div>
    }
  </div>
</dashboard-widget>
